import { Button, Card, Checkbox, Popconfirm } from "antd";
import { useDispatch } from "react-redux";
import {
  deleteAddresse,
  updateSaveAddresse,
} from "../AddressesSlice/Addresses.slice";
import CustomForm from "../../../components/CustomForm";
import React, { useRef, useState } from "react";
import { userHasLevel } from "../../../../engine/AuthRoute";
import routes from "../../../../engine/routes";
import { inputsAddresseItem } from "./AddresseItemInputs";
import { addresseItemMapsInputs } from "./AddresseItemMapsInputs";
import { typeAddress } from "./AddresseHelpers";
import { truncateDecimal } from "../../../../utils/helpersFunction";
import { useTranslation } from "react-i18next";

export const AddresseItem = ({
  address,
  defaultId = null,
  changeDefault,
  isChecked,
  institution,
  type,
  principal,
  isNew = false,
}) => {
  const { _id } = address;

  const formRef = useRef(null);

  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);

  const { t } = useTranslation(); // Initialize useTranslation

  const deleteItem = () => {
    dispatch(deleteAddresse(address));
    if (isChecked) {
      changeDefault(null);
    }
  };

  const {
    complement,
    number,
    person,
    external,
    street,
    description,
    principal: principalAdress,
    institution: institutionAdress,
    location,
    maps,
    city,
    canton,
    beneficiary,
    zip,
    country,
    sharedToInstitutions = [],
  } = address;

  const handleSubmit = data => {
    let payload = {};

    if (type === typeAddress.postal) {
      payload = {
        ...data.address,
        sharedToInstitutions: data?.sharedToInstitutions || [],
        description: data.description,
        _id: address._id,
      };
    }

    if (type === typeAddress.maps) {
      const allData = formRef.current.getFieldsValue(true);

      payload = {
        _id: address._id,
        ...data,
      };

      if (
        allData.maps !== undefined &&
        allData.lng_maps !== undefined &&
        allData.canton_maps !== undefined &&
        allData.lat_maps !== undefined
      ) {
        payload.longitude = truncateDecimal(allData?.lng_maps || 0, 5);
        payload.latitude = truncateDecimal(allData?.lat_maps || 0, 5);
        payload.canton = allData?.canton_maps || "";
      }
    }

    dispatch(updateSaveAddresse(payload));
  };

  const changeEdition = () => {
    setIsEdit(!isEdit);
  };

  const renderAddress = () => {
    return (
      <span>
        <b>{beneficiary}</b>
        {person && (
          <>
            <br />
            <b>{person}</b>
          </>
        )}
        <br />

        <span>
          {street} {number}
          <br />
          {complement && (
            <>
              {complement}
              <br />
            </>
          )}
          {zip} {city}
          <br />
          {canton} {country}
        </span>
        {(external || sharedToInstitutions.length > 0) && (
          <>
            <br />
            <div
              style={{
                width: "300px",
                height: "1px",
                background: "#b2b1b1",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            />
            {external && (
              <>
                <cite>*{t("addresseItem.externalInstitutionNote")}</cite>
              </>
            )}
            {sharedToInstitutions.length > 0 && (
              <>
                <br />
                <b>
                  {t("addresseItem.sharedWith")} {sharedToInstitutions.length}{" "}
                  {t("addresseItem.institution", {
                    count: sharedToInstitutions.length,
                  })}
                </b>
              </>
            )}
          </>
        )}
      </span>
    );
  };

  const renderMaps = () => {
    return (
      <span>
        <b>{maps}</b>
      </span>
    );
  };

  const addressPrincipalToInstitution = () => {
    return (
      institution !== null &&
      address.principal !== null &&
      address.institution === null
    );
  };

  const isAdressShared = () => {
    return (
      address.principal === null &&
      address.institution !== null &&
      address.institution._id !== institution._id
    );
  };

  const userCanUpdate = userHasLevel(
    type === typeAddress.maps
      ? routes.institutions().locations
      : routes.institutions().addresses,
    "u",
  );

  const userCanChangeAddress = () => {
    if (isAdressShared()) {
      return true;
    }

    if (addressPrincipalToInstitution()) {
      return true;
    } else {
      return !userCanUpdate;
    }
  };

  const renderText = () => {
    return type === typeAddress.postal ? renderAddress() : renderMaps();
  };

  return (
    <>
      <Card
        key={_id}
        title={<>{type === typeAddress.postal ? description : location}</>}
        extra={[
          addressPrincipalToInstitution() && principal === null ? (
            <b style={{ marginRight: 10 }}>
              {t("addresseItem.mandant")} {principalAdress.name}
            </b>
          ) : null,
          institutionAdress !== null &&
          institutionAdress?._id !== institution?._id ? (
            <b style={{ marginRight: 10 }}>
              {t("addresseItem.institution")} {institutionAdress?.name}
            </b>
          ) : null,
          <Button
            disabled={userCanChangeAddress()}
            onClick={changeEdition}
            size={"small"}
            type={"primary"}
            style={{ marginRight: 10 }}
          >
            {isEdit ? t("addresseItem.cancel") : t("addresseItem.edit")}
          </Button>,
          <Popconfirm
            disabled={!isEdit && userCanChangeAddress()}
            title={t("addresseItem.deleteTitle")}
            description={t("addresseItem.deleteDescription")}
            onConfirm={deleteItem}
            onCancel={() => {}}
            okText={t("addresseItem.yes")}
            cancelText={t("addresseItem.no")}
          >
            <Button
              disabled={!isEdit && userCanChangeAddress()}
              size={"small"}
              type={"primary"}
            >
              {t("addresseItem.delete")}
            </Button>
          </Popconfirm>,
        ]}
        footer={<p>hello</p>}
      >
        {isEdit ? (
          <CustomForm
            refForm={formRef}
            disabled={!userCanUpdate}
            dataSource={
              type === typeAddress.postal
                ? inputsAddresseItem({
                    address,
                    description,
                    changeEdition,
                    sharedToInstitutions,
                  })
                : addresseItemMapsInputs({
                    location,
                    maps,
                    changeEdition,
                  })
            }
            labelCol={24}
            wrapperCol={24}
            handleSubmit={handleSubmit}
          />
        ) : (
          renderText()
        )}
      </Card>
      <br />
      <label disabled={isChecked}>
        <Checkbox
          disabled={isChecked || !userCanUpdate}
          checked={isChecked}
          size={"large"}
          onChange={() => changeDefault(address)}
        />
        <span style={{ padding: 5 }}>{t("addresseItem.defaultAddress")}</span>
      </label>
    </>
  );
};
